import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
  }

  disconnect() {
  }

  moveUp(event) {
    const previousElement = this.element.previousElementSibling;
    if (previousElement) {
      this.element.parentNode.insertBefore(this.element, previousElement);
    }
    event.preventDefault();
    return false;
  }

  moveDown(event) {
    const nextElement = this.element.nextElementSibling;
    if (nextElement) {
      this.element.parentNode.insertBefore(nextElement, this.element);
    }
    event.preventDefault();
    return false;
  }

  remove(event) {
    this.element.remove()
    event.preventDefault();
    return false;
  }
}
